var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerticonmodal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "47px",
    viewBox: "0 0 53 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19032664-4D67-409F-8924-CD6A26CD3B3E@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---My-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    transform: "translate(-512.000000, -543.000000)",
    fill: "#FFB81C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(471.500000, 486.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0306728,98.7726353 L70.0056258,58.7397323 C68.6709978,56.4200892 65.3290018,56.4200892 63.9943738,58.7397323 L40.9693268,98.7726353 C39.6346988,101.092278 41.3056968,104 43.9749528,104 L90.0250468,104 C92.6943028,104 94.3653008,101.092278 93.0306728,98.7726353 Z M67.0049198,71.0000002 C68.4065008,71.0000002 69.5401328,72.2269272 69.4989098,73.7035833 L69.0866798,88.8610212 C69.0557628,90.0553752 68.1282458,91.0000002 66.9946138,91.0000002 C65.8609818,91.0000002 64.9334648,90.0445173 64.9025468,88.8610212 L64.5006228,73.7035833 C64.4697058,72.2269272 65.5930318,71.0000002 67.0049198,71.0000002 Z M66.9999998,98.0000002 C65.6210318,98.0000002 64.4999998,96.8789682 64.4999998,95.5000002 C64.4999998,94.1210323 65.6210318,93.0000002 66.9999998,93.0000002 C68.3789678,93.0000002 69.4999998,94.1210323 69.4999998,95.5000002 C69.4999998,96.8789682 68.3789678,98.0000002 66.9999998,98.0000002 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerticonmodal);
export default __webpack_public_path__ + "static/media/Alerticonmodal.1c15fbe590cf05935445c6f715e92716.svg";
export { ForwardRef as ReactComponent };